<div class="flex h-[calc(100vh-64px)] bg-gray-50">
  <!-- Sidebar: Conversaciones -->
  <div
    class="bg-white border-r border-gray-200 flex flex-col transition-all duration-300"
    [class.w-72]="showSidebar"
    [class.w-0]="!showSidebar"
    [class.overflow-hidden]="!showSidebar"
  >
    <!-- Header sidebar -->
    <div class="p-4 border-b border-gray-200">
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
          <mat-icon class="text-green-600">smart_toy</mat-icon>
          Aguacate AI
        </h2>
        <button
          mat-icon-button
          (click)="toggleSidebar()"
          class="text-gray-500"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <button
        mat-raised-button
        color="primary"
        class="w-full"
        (click)="newConversation()"
      >
        <mat-icon>add</mat-icon>
        Nueva conversacion
      </button>
    </div>

    <!-- Lista de conversaciones -->
    <div class="flex-1 overflow-y-auto">
      <div
        *ngFor="let conv of ctrl.conversations"
        class="px-3 py-2 cursor-pointer hover:bg-gray-50 border-b border-gray-100 group"
        [class.bg-green-50]="ctrl.currentConversation?.id === conv.id"
        [class.border-l-4]="ctrl.currentConversation?.id === conv.id"
        [class.border-l-green-500]="ctrl.currentConversation?.id === conv.id"
        (click)="selectConversation(conv)"
      >
        <div class="flex items-center justify-between">
          <p class="text-sm font-medium text-gray-700 truncate flex-1">
            {{ conv.title || 'Sin titulo' }}
          </p>
          <button
            mat-icon-button
            class="opacity-0 group-hover:opacity-100 transition-opacity"
            (click)="deleteConversation(conv, $event)"
            matTooltip="Archivar"
          >
            <mat-icon class="text-gray-400 text-sm">delete_outline</mat-icon>
          </button>
        </div>
        <p class="text-xs text-gray-400 mt-0.5">
          {{ conv.messageCount }} msgs
        </p>
      </div>

      <div
        *ngIf="ctrl.conversations.length === 0"
        class="p-4 text-center text-gray-400 text-sm"
      >
        Sin conversaciones
      </div>
    </div>
  </div>

  <!-- Chat principal -->
  <div class="flex-1 flex flex-col min-w-0">
    <!-- Header chat -->
    <div
      class="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3"
    >
      <button
        *ngIf="!showSidebar"
        mat-icon-button
        (click)="toggleSidebar()"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <mat-icon class="text-green-600">smart_toy</mat-icon>
      <div class="flex-1">
        <h1 class="text-base font-semibold text-gray-800">
          {{ ctrl.currentConversation?.title || 'Aguacate AI Chat' }}
        </h1>
        <p class="text-xs text-gray-400" *ngIf="ctrl.currentConversation">
          {{ ctrl.currentConversation.messageCount }} mensajes
        </p>
      </div>
      <div
        *ngIf="ctrl.isStreaming && ctrl.currentToolName"
        class="flex items-center gap-2 text-xs text-blue-600 bg-blue-50 px-3 py-1 rounded-full"
      >
        <mat-spinner diameter="14"></mat-spinner>
        {{ formatToolName(ctrl.currentToolName) }}
      </div>
    </div>

    <!-- Mensajes -->
    <div
      #chatContainer
      class="flex-1 overflow-y-auto px-4 py-4 space-y-4"
    >
      <!-- Estado vacio -->
      <div
        *ngIf="!ctrl.currentConversation"
        class="flex flex-col items-center justify-center h-full text-gray-400"
      >
        <mat-icon class="text-6xl text-green-200 mb-4">psychology</mat-icon>
        <p class="text-lg font-medium text-gray-500">Aguacate AI</p>
        <p class="text-sm mt-1">
          Crea una conversacion para comenzar a consultar datos de la plataforma
        </p>
        <div class="mt-6 grid grid-cols-2 gap-3 max-w-lg">
          <div class="bg-white rounded-lg p-3 border text-sm text-gray-600">
            <mat-icon class="text-green-500 text-base mr-1">trending_up</mat-icon>
            "Cuantas transacciones hubo hoy?"
          </div>
          <div class="bg-white rounded-lg p-3 border text-sm text-gray-600">
            <mat-icon class="text-blue-500 text-base mr-1">account_balance</mat-icon>
            "Cual es la tasa actual CLP/VES?"
          </div>
          <div class="bg-white rounded-lg p-3 border text-sm text-gray-600">
            <mat-icon class="text-orange-500 text-base mr-1">people</mat-icon>
            "Top 10 usuarios por volumen este mes"
          </div>
          <div class="bg-white rounded-lg p-3 border text-sm text-gray-600">
            <mat-icon class="text-purple-500 text-base mr-1">analytics</mat-icon>
            "Compara esta semana con la anterior"
          </div>
        </div>
      </div>

      <!-- Loading conversacion -->
      <div *ngIf="ctrl.isLoading" class="flex justify-center py-8">
        <mat-spinner diameter="32"></mat-spinner>
      </div>

      <!-- Mensajes del chat -->
      <ng-container *ngIf="ctrl.currentConversation && !ctrl.isLoading">
        <div *ngFor="let msg of ctrl.messages" class="flex" [ngClass]="{
          'justify-end': msg.role === 'user',
          'justify-start': msg.role !== 'user'
        }">
          <!-- Mensaje usuario -->
          <div
            *ngIf="msg.role === 'user'"
            class="max-w-[75%] bg-green-600 text-white rounded-2xl rounded-br-md px-4 py-2.5 shadow-sm"
          >
            <p class="text-sm whitespace-pre-wrap">{{ msg.content }}</p>
          </div>

          <!-- Mensaje assistant -->
          <div
            *ngIf="msg.role === 'assistant'"
            class="max-w-[85%] bg-white rounded-2xl rounded-bl-md px-4 py-2.5 shadow-sm border border-gray-100"
          >
            <p class="text-sm text-gray-800 whitespace-pre-wrap">{{ msg.content }}</p>
            <div *ngIf="msg.usage" class="mt-2 text-xs text-gray-300">
              {{ msg.usage.inputTokens + msg.usage.outputTokens }} tokens
              <span *ngIf="msg.usage.estimatedCostUsd">
                ~ ${{ msg.usage.estimatedCostUsd.toFixed(4) }}
              </span>
            </div>
          </div>

          <!-- Tool indicator -->
          <div
            *ngIf="msg.role === 'tool'"
            class="flex items-center gap-2 text-xs text-blue-500 bg-blue-50 px-3 py-1.5 rounded-full"
          >
            <mat-icon class="text-sm">build</mat-icon>
            {{ msg.content }}
          </div>

          <!-- Error -->
          <div
            *ngIf="msg.role === 'error'"
            class="max-w-[75%] rounded-2xl px-4 py-2.5 border"
            [class.bg-red-50]="!msg.rateLimited"
            [class.border-red-200]="!msg.rateLimited"
            [class.text-red-700]="!msg.rateLimited"
            [class.bg-yellow-50]="msg.rateLimited"
            [class.border-yellow-200]="msg.rateLimited"
            [class.text-yellow-800]="msg.rateLimited"
          >
            <div class="flex items-center gap-2">
              <mat-icon class="text-sm">
                {{ msg.rateLimited ? 'hourglass_top' : 'error_outline' }}
              </mat-icon>
              <p class="text-sm">{{ msg.content }}</p>
            </div>
          </div>
        </div>

        <!-- Streaming en progreso -->
        <div *ngIf="ctrl.isStreaming" class="flex justify-start">
          <!-- Thinking -->
          <div
            *ngIf="ctrl.thinkingText && !ctrl.streamingText"
            class="max-w-[85%] bg-purple-50 border border-purple-100 rounded-2xl rounded-bl-md px-4 py-2.5"
          >
            <div class="flex items-center gap-2 text-purple-600 text-xs mb-1">
              <mat-spinner diameter="12"></mat-spinner>
              Analizando...
            </div>
            <p class="text-xs text-purple-500 whitespace-pre-wrap">{{ ctrl.thinkingText | slice:0:200 }}</p>
          </div>

          <!-- Texto streaming -->
          <div
            *ngIf="ctrl.streamingText"
            class="max-w-[85%] bg-white rounded-2xl rounded-bl-md px-4 py-2.5 shadow-sm border border-gray-100"
          >
            <p class="text-sm text-gray-800 whitespace-pre-wrap">{{ ctrl.streamingText }}</p>
            <div class="flex items-center gap-1 mt-1">
              <span class="inline-block w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></span>
            </div>
          </div>

          <!-- Waiting sin texto -->
          <div
            *ngIf="!ctrl.streamingText && !ctrl.thinkingText"
            class="flex items-center gap-2 text-gray-400 text-sm"
          >
            <mat-spinner diameter="16"></mat-spinner>
            {{ deepMode ? 'Análisis profundo en proceso...' : 'Pensando...' }}
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Input -->
    <div
      *ngIf="ctrl.currentConversation"
      class="bg-white border-t border-gray-200 px-4 py-3"
    >
      <div class="flex items-end gap-2 max-w-4xl mx-auto">
        <button
          mat-icon-button
          [color]="deepMode ? 'accent' : ''"
          (click)="toggleDeepMode()"
          [matTooltip]="deepMode ? 'Modo análisis profundo activo (más lento, más preciso)' : 'Activar análisis profundo'"
          [disabled]="ctrl.isStreaming"
        >
          <mat-icon>{{ deepMode ? 'psychology_alt' : 'psychology' }}</mat-icon>
        </button>

        <textarea
          #messageInput
          [(ngModel)]="inputMessage"
          (keydown)="onKeyDown($event)"
          [disabled]="ctrl.isStreaming"
          [placeholder]="deepMode ? 'Consulta compleja (análisis profundo)...' : 'Escribe tu consulta...'"
          class="flex-1 resize-none border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent max-h-32"
          rows="1"
        ></textarea>

        <button
          *ngIf="!ctrl.isStreaming"
          mat-fab
          color="primary"
          [disabled]="!inputMessage.trim()"
          (click)="sendMessage()"
          class="shrink-0"
        >
          <mat-icon>send</mat-icon>
        </button>

        <button
          *ngIf="ctrl.isStreaming"
          mat-fab
          color="warn"
          (click)="stopStreaming()"
          class="shrink-0"
          matTooltip="Detener respuesta"
        >
          <mat-icon>stop</mat-icon>
        </button>
      </div>
      <p class="text-xs text-gray-400 text-center mt-2">
        Aguacate AI puede consultar transacciones, tasas, saldos, analytics y mas. Solo lectura.
      </p>
    </div>
  </div>
</div>
